import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';

export const SignUpTitle = () => {
    return (
        <Typography as="h1" color="neutral-900" variant="heading-sm">
            {gettext('Create an account to preview your event')}
        </Typography>
    );
};
